// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"589":"f5a00fb6a3530cb2","638":"eab6f22e59749076"}[chunkId] + ".js";
};